import { withInstall } from '@pit-element-plus/utils'
import FormBase from './src/form-base.vue'

import type { SFCWithInstall } from '@pit-element-plus/utils'

export const ElFormBase: SFCWithInstall<typeof FormBase> = withInstall(FormBase)
export default ElFormBase

export * from './src/form-base'
export * from './src/constants'

export type ElFormBaseInstance = InstanceType<typeof FormBase> & unknown
